'use strict';
import React, { Component } from 'react';


class CuentaCliente extends Component {
    constructor(props) {
        super(props);
    }


    componentDidMount() {

        //this.props.getScreenData(this.props.currentScope);
    }

    componentWillUnmount() {
    }

    render() {
        const { data } = this.props;

        return (
            <div>
                <div className="col-md-12 bottom-separator-grey ">
                    <div className="row ">
                        <div className="col-md-10 no-gutters">
                            ------------HOLAAAAAA-----------------
                            {
                                //<ClienteHeader datosCliente={data.CONSULTA_SOLICITUD_CUENTA_CLIENTE} cliente={this.props.tarjetas.clienteResultadoBusqueda} />
                            }
                        </div>
                        <div className="col-md-2 no-gutters">
                            {
                                //<GenericModalButton id="btnDataCliente" buttonClass="btn btn-secondary float-right top-separator-xs" type="button" text="Datos Cliente" dataTarget="#soloDatos" />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

export default CuentaCliente;